import { isEmpty, first } from 'lodash';

export default function onImageBeforeUpload(images) {
  this.popups.hideAll();

  if (!isEmpty(images) && first(images) instanceof File) {
    const reader = new FileReader();

    reader.onload = ({ target: { result } }) => {
      this.image.insert(result, null, null, this.image.get());
    };
    reader.readAsDataURL(images[0]);
  }

  return false;
}
